import PropTypes from 'prop-types'

// Seller
import sellerGirlLocked from 'assets/characters/seller-girl-locked.png'
import sellerGuyLocked from 'assets/characters/seller-guy-locked.png'
import sellerGirl from 'assets/characters/seller-girl.png'
import sellerGuy from 'assets/characters/seller-guy.png'
import sellerGuyBordered from 'assets/characters/seller-guy-bordered.png'

// R&D
import rdGirl from 'assets/characters/rd-girl.png'
import rdGuy from 'assets/characters/rd-guy.png'
import rdGirlLocked from 'assets/characters/rd-girl-locked.png'
import rdGuyLocked from 'assets/characters/rd-guy-locked.png'
import rdGirlBordered from 'assets/characters/rd-girl-bordered.png'

// Worker
import workerGirl from 'assets/characters/worker-girl.png'
import workerGuy from 'assets/characters/worker-guy.png'
import workerGuyBordered from 'assets/characters/worker-guy-bordered.png'

// Super Worker
import superWorkerGirl from 'assets/characters/super-worker-girl.png'
import superWorkerGuy from 'assets/characters/super-worker-guy.png'
import superWorkerGirlBordered from 'assets/characters/super-worker-girl-bordered.png'

// Storage Worker
import storageWorkerGirl from 'assets/characters/storage-worker-girl.png'
import storageWorkerGuy from 'assets/characters/storage-worker-guy.png'
import storageWorkerGirlLocked from 'assets/characters/storage-worker-girl-locked.png'
import storageWorkerGuyLocked from 'assets/characters/storage-worker-guy-locked.png'

// Admin
import AdminGirl from 'assets/characters/admin-girl.png'

// CEO
import CeoGuy from 'assets/characters/ceo-guy.png'

import { EMPLOYEES_TYPE, GENDERS } from 'constants/employees'

export function characterByType({ type, gender, unlock, bordered = false }) {
  // Seller
  if (EMPLOYEES_TYPE.seller === type && bordered)
    return GENDERS.guy === gender ? sellerGuyBordered : sellerGuyBordered
  if (EMPLOYEES_TYPE.seller === type && unlock)
    return GENDERS.guy === gender ? sellerGuy : sellerGirl
  if (EMPLOYEES_TYPE.seller === type && !unlock)
    return GENDERS.guy === gender ? sellerGuyLocked : sellerGirlLocked

  // R&D
  if (EMPLOYEES_TYPE.rd === type && bordered)
    return GENDERS.guy === gender ? rdGirlBordered : rdGirlBordered
  if (EMPLOYEES_TYPE.rd === type && unlock) return GENDERS.guy === gender ? rdGuy : rdGirl
  if (EMPLOYEES_TYPE.rd === type && !unlock)
    return GENDERS.guy === gender ? rdGuyLocked : rdGirlLocked

  // Worker
  if (EMPLOYEES_TYPE.worker === type && bordered)
    return GENDERS.guy === gender ? workerGuyBordered : workerGuyBordered
  if (EMPLOYEES_TYPE.worker === type && unlock)
    return GENDERS.guy === gender ? workerGuy : workerGirl
  if (EMPLOYEES_TYPE.worker === type && !unlock)
    return GENDERS.guy === gender ? workerGuy : workerGirl

  // Super Worker
  if (EMPLOYEES_TYPE.super_worker === type && bordered)
    return GENDERS.guy === gender ? superWorkerGirlBordered : superWorkerGirlBordered
  if (EMPLOYEES_TYPE.super_worker === type && unlock)
    return GENDERS.guy === gender ? superWorkerGuy : superWorkerGirl
  if (EMPLOYEES_TYPE.super_worker === type && !unlock)
    return GENDERS.guy === gender ? superWorkerGuy : superWorkerGirl

  // Storage Worker
  if (EMPLOYEES_TYPE.storage_worker === type && unlock)
    return GENDERS.guy === gender ? storageWorkerGuy : storageWorkerGirl
  if (EMPLOYEES_TYPE.storage_worker === type && !unlock)
    return GENDERS.guy === gender ? storageWorkerGuyLocked : storageWorkerGirlLocked

  // Admin
  if (EMPLOYEES_TYPE.admin === type) return GENDERS.guy === gender ? AdminGirl : AdminGirl

  // CEO
  if (EMPLOYEES_TYPE.ceo === type) return GENDERS.guy === gender ? CeoGuy : CeoGuy

  return GENDERS.guy === gender ? superWorkerGuy : superWorkerGirl
}

characterByType.propTypes = {
  gender: PropTypes.oneOf(GENDERS).isRequired,
  type: PropTypes.oneOf(EMPLOYEES_TYPE).isRequired,
  unlock: PropTypes.bool.isRequired
}

export function toogleGender({ index, unlock, type }) {
  const even = index % 2 === 0

  if (even) return characterByType({ type, gender: GENDERS.guy, unlock })

  return characterByType({ type, gender: GENDERS.girl, unlock })
}

toogleGender.propTypes = {
  index: PropTypes.number.isRequired,
  unlock: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(EMPLOYEES_TYPE).isRequired
}
